import { render } from "./TableAccounting.vue?vue&type=template&id=598852cf&scoped=true"
import script from "./TableAccounting.vue?vue&type=script&lang=js"
export * from "./TableAccounting.vue?vue&type=script&lang=js"

import "./TableAccounting.vue?vue&type=style&index=0&id=598852cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-598852cf"

export default script